var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRelief(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 15914"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9",
    cx: 28,
    cy: 28,
    r: 25,
    fill: "#6C6C6C",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 13",
    d: "M14 29C16.0025 34.8071 21.7375 39 28.5 39C35.2625 39 40.9975 34.8071 43 29",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 18",
    d: "M37.5 27L37.5 26.05C37.5 23.8132 35.933 22 34 22C32.067 22 30.5 23.8132 30.5 26.05L30.5 27",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 19",
    d: "M26 27L26 26.05C26 23.8132 24.433 22 22.5 22C20.567 22 19 23.8132 19 26.05L19 27",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 20",
    d: "M42.0088 15.3789C42.1905 15.7806 42.3862 16.2205 42.5811 16.6748C42.9517 17.5387 43.3162 18.4414 43.5859 19.2256C43.872 20.0574 44 20.6152 44 20.8574L43.9893 21.083C43.8819 22.191 42.9934 23 42 23C40.9711 23 40.0002 21.9552 40 20.8574C40 20.7893 40.0209 20.617 40.0977 20.3154C40.1701 20.0307 40.2777 19.685 40.4131 19.2949C40.6837 18.5152 41.0496 17.6046 41.4209 16.7295C41.6216 16.2565 41.8225 15.7972 42.0088 15.3789Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelief);
export default __webpack_public_path__ + "static/media/Relief.766996738051f569f26f1f8e68306007.svg";
export { ForwardRef as ReactComponent };